import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
import { Pill } from "../../../primitives/data-display/Pill";
import { gaps } from "../../../primitives/spacing";
import type { ExpertInsightSummary } from "../../../../lib/expert_insights_api";

export interface InsightStatusPillsProps {
  insight: ExpertInsightSummary;
}

/** Status pill(s) for an insight: published, draft, pending changes, or withdrawn. */
export function InsightStatusPills({ insight }: InsightStatusPillsProps) {
  const { t } = useTranslation();
  if (insight.status === "withdrawn") {
    return <Pill label={t("expertInsights.insights.status.withdrawn")} tone="muted" />;
  }
  const hasPublished = insight.currentVersion !== null;
  const hasDraft = insight.draft !== null;
  return (
    <Stack direction="row" gap={gaps.snug}>
      {hasPublished && <Pill label={t("expertInsights.insights.status.published")} tone="accent" />}
      {hasDraft && !hasPublished && (
        <Pill label={t("expertInsights.insights.status.draft")} tone="muted" />
      )}
      {hasDraft && hasPublished && (
        <Pill label={t("expertInsights.insights.status.pendingChanges")} tone="warning" />
      )}
    </Stack>
  );
}
